import React from "react";

const Col = props => {
  return <div className="col col-lg-4">{props.children}</div>;
};

export default Col;
